<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      {{ title }}
    </template>
    <template v-slot:body>
      <ValidationObserver ref="newMicrosite">
        <ValidationProvider v-slot="{ errors }" name="name" rules="required">
          <v-text-field
            class="mt-10"
            v-model="name"
            label="Name"
            :error-messages="showValidationErrors ? errors : ''"
          />
        </ValidationProvider>
      </ValidationObserver>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="close" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          {{ buttonLabel }}
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import BaseDialog from "@/components/common/BaseDialog";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { MICROSITE_NAMESPACE } from "@/store/modules/microsites";
import {
  ADD_MICROSITE,
  EDIT_MICROSITE
} from "@/store/modules/microsites/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(MICROSITE_NAMESPACE);

export default {
  components: {
    BaseDialog,
    PrimaryButton,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    isOpen: Boolean,
    microsite: Object,
    isUpdate: Boolean
  },
  data() {
    return {
      name: this.isUpdate ? this.microsite.name : "",
      showValidationErrors: false,
      isLoading: false
    };
  },
  computed: {
    title() {
      return this.isUpdate ? "Edit Title" : "New Microsite";
    },
    buttonLabel() {
      return this.isUpdate ? "Save Changes" : " Create Microsite";
    }
  },
  methods: {
    ...mapActions({
      addMicrosite: ADD_MICROSITE,
      editMicrosite: EDIT_MICROSITE
    }),
    close() {
      this.$emit("close");
    },
    async handleSubmit() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.newMicrosite.validate();
      if (isValid) {
        this.isLoading = true;
        this.isUpdate
          ? await this.editMicrosite({ name: this.name, id: this.microsite.id })
          : await this.addMicrosite({ name: this.name, isLive: 1 });
        this.isLoading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>
